import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { GoogleAnalyticsStoreService } from '@core-layout/app/store/services/google-analytics-store.service';
import { CustomerSettings } from '@settings/models/settings/customer-settings';
import { SettingsStoreService } from '@settings/store/services/settings-store.service';
import { UpdatePasswordModel } from '../../interfaces/customer-settings/update-password-model';
import { ProfileBaseStoreService } from '../../store/services/profile-base-store.service';
import { NewMatchSettingsModel } from '../../interfaces/new-match-settings/new-match-settings.model';
import { EmailAlertSettingsComponent } from '../email-alert-settings/email-alert-settings.component';
import { NewMatchSettingsComponent } from '../new-match-settings/new-match-settings.component';
import { RpcSlideToggleComponent } from '../../../../../core-modules/controls/components/rpc-slide-toggle/rpc-slide-toggle.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { RpcButtonComponent } from '../../../../../core-modules/controls/components/rpc-button/rpc-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'profile-settings',
    templateUrl: './profile-settings.component.html',
    styleUrls: ['./profile-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EmailAlertSettingsComponent, NewMatchSettingsComponent, RpcSlideToggleComponent, ChangePasswordComponent, RpcButtonComponent, TranslateModule]
})
export class ProfileSettingsComponent {
    @Input() public isSelfProfile: boolean;
    @Input() public settings: CustomerSettings;
    @Input() public newMatchSettings: NewMatchSettingsModel;
    @Input() public isSmsAvailable = true;
    @Input() public hasSmsAlertsNumber = false;

    constructor(
        private readonly settingsStoreService: SettingsStoreService,
        private readonly googleAnalyticsStoreService: GoogleAnalyticsStoreService,
        private readonly profileBaseStoreService: ProfileBaseStoreService,
    ) { }

    public onSettingsChanged(settings: CustomerSettings): void {
        this.profileBaseStoreService.updateSettings(settings);
    }

    public onDarkModeSelected(isDarkMode: boolean): void {
        this.googleAnalyticsStoreService.addDarkModeChangedEvent(isDarkMode ? 'on' : 'off');

        this.settingsStoreService.updateLayoutSettings({ darkMode: isDarkMode });
    }

    public onPasswordChanged(model: UpdatePasswordModel): void {
        this.profileBaseStoreService.updatePassword(model.data);
    }

    public onDeactivateAccount(): void {
        this.profileBaseStoreService.showDeactivateAccountDialog();
    }

    public onNewMatchSettingsChanged(settings: NewMatchSettingsModel): void {
        this.profileBaseStoreService.updateNewMatchSettings(settings);
    }
}
